import React from "react";
import { Typography, Row, Col, Empty } from "antd";
import PropertyCard from "../common/PropertyCard";

const { Title, Text, Paragraph } = Typography;

const ListedPropertiesSection = ({
  title,
  description,
  listings,
  emptyMessage = "No properties available",
}) => (
  <div style={{ textAlign: "center", marginTop: 60 }}>
    <Title level={3} style={{ fontWeight: "bold" }}>
      {title}
    </Title>
    <Paragraph style={{ color: "#555", maxWidth: 650, margin: "0 auto" }}>
      {description}
    </Paragraph>

    <div style={{ padding: "40px 10%" }}>
      {listings && listings.length > 0 ? (
        <Row gutter={[24, 24]} justify="left">
          {listings.map((property, index) => (
            <Col
              key={property?.id || index}
              xs={24}
              sm={12}
              md={8}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <PropertyCard property={property} />
            </Col>
          ))}
        </Row>
      ) : (
        <Empty description={emptyMessage} style={{ margin: "40px 0" }} />
      )}
    </div>
  </div>
);

export default ListedPropertiesSection;
